"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ['itemDetail'],
  data: function data() {
    return {
      dataList: [],
      slideList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    (0, _customPage.moduleDetail)({
      moduleId: this.$props.itemDetail.moduleId
    }).then(function (res) {
      // console.log(res)
      _this.dataList = res.data.banner;
      if (_this.$props.itemDetail.componentCode === 'diamond' && _this.$props.itemDetail.componentSubcode === 's_a') {
        // 可滑动新增，需要自己组合数据
        _this.slideList = [];
        // console.log(res.data.banner, '哈哈哈', this.paginateArray(res.data.banner, 10, 1))
        var num = Math.ceil(res.data.banner.length / 10);
        var arr = [];
        for (var i = 0; i < num; i++) {
          arr.push(_this.paginateArray(res.data.banner, 10, i + 1));
        }
        _this.slideList = arr;
        // console.log(this.slideList, this.dataList, '滑动！！！！！！！！！！！！')
      }
    });
  },
  methods: {
    paginateArray: function paginateArray(array, pageSize, pageNumber) {
      // 计算开始索引
      var startIndex = (pageNumber - 1) * pageSize;
      // 计算结束索引
      var endIndex = startIndex + pageSize;
      // 返回当前页的数据
      return array.slice(startIndex, endIndex);
    }
  }
};